import { HTTPClientInterface, HTTPRequest } from '@shared/core/HTTPClientInterface';
import { buildURL, SystemURL } from './URLCatalog';
import { Logger } from '@utils/Logger';

export interface LeaveAbsenseRequest {
	firestoreRecordId: string;
	organizationID: string;
	id: string;
	userID: string;
	fromDate: string; // ISO date string
	toDate: string; // ISO date string
	reason: string;
	timestamp: number; // Unix timestamp in milliseconds
	firestoreCreationTimestamp: number; // Unix timestamp in milliseconds
	state: string; // e.g., "PENDING"
	firestoreUpdateTimestamp: number; // Unix timestamp in milliseconds
}

export interface User {
	id: string;
	name: string;
	image: string; // URL to the user's image
}

export interface LeaveAbsenseResponse {
	request: LeaveAbsenseRequest;
	user: User;
	days: number;
	reasonDescription: string;
}
export class LeaveAbsenseService {
	private httpClient: HTTPClientInterface;

	constructor(httpClient: HTTPClientInterface) {
		this.httpClient = httpClient;
	}

	async getPendingLeaveAbsenseRequests(
		organizationID: string,
	): Promise<Array<LeaveAbsenseResponse>> {
		let request = new HTTPRequest();
		request.url = buildURL(SystemURL.LeaveAbsense.getPendingRequests, {
			org_id: organizationID,
		});
		request.method = 'GET';
		const response = await this.httpClient.execute(request);
        return response.result as Promise<Array<LeaveAbsenseResponse>>;
	}

	async getProcessedLeaveAbsenseRequests(
		organizationID: string,
	): Promise<Array<LeaveAbsenseResponse>> {
		let request = new HTTPRequest();
		request.url = buildURL(SystemURL.LeaveAbsense.getProcessedRequests, {
			org_id: organizationID,
		});
		request.method = 'GET';
        const response = await this.httpClient.execute(request);
        return response.result as Promise<Array<LeaveAbsenseResponse>>;
	}

	async approvePendingLeaveAbsenseRequest(flowToken: string, description: string): Promise<any> {
		let request = new HTTPRequest();
		request.url = buildURL(SystemURL.LeaveAbsense.postApproveRequest, {
			flow_token: flowToken,
		});
		request.method = 'POST';
		request.body = {
			description: description ?? '',
		};
		return this.httpClient.execute(request) as Promise<any>;
	}

	async rejectPendingLeaveAbsenseRequest(flowToken: string, description: string): Promise<any> {
		let request = new HTTPRequest();
		request.url = buildURL(SystemURL.LeaveAbsense.postRejectRequest, {
			flow_token: flowToken,
		});
		request.method = 'POST';
		request.body = {
			description: description,
		};
		return this.httpClient.execute(request) as Promise<any>;
	}
}
